<template>
  <div class="anniversary_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'《使魔计划》周年庆典'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-smjh' v-show='preloadingShow'></div>
    </transition>
    <div class="content">
      <div class="first_page ">
        <div class="logo"></div>
        <div class="title"></div>
        <div class="btn_box">
          <div class="tap-btn " data-event="taptap"
            @click="goHere('https://tap.cn/utZqQptX?channel=rep-rep_irbfyeyluhl')"> </div>
          <div class="wx-btn " data-event="wx" @click="goHere('wx')"> </div>
          <div class=" weibo-btn " data-event="weibo" @click="goHere('https://weibo.com/u/6573151992')"></div>
        </div>
        <div class=" download-btn download  android" @click="onDownloadApi()"></div>
        <div class="arrow_down ani-01"></div>
      </div>
      <div class="second_page ">
        <div class="main-bgc">
          <div>
            <div class="puzzle-1" v-if="signProgress < 1"></div>
            <div class="puzzle-2" v-if="signProgress < 2"></div>
            <div class="puzzle-3" v-if="signProgress < 3"></div>
            <div class="puzzle-4" v-if="signProgress < 4"></div>
            <div class="puzzle-5" v-if="signProgress < 5"></div>
            <div class="puzzle-6" v-if="signProgress < 6"></div>
            <div class="puzzle-7" v-if="signProgress < 7"></div>
          </div>
        </div>
        <div class="bot-btn">
          <div class="sign-btn" @click="signBtn()"></div>
          <div class="share-btn" @click="sharePopupBtn()"></div>
        </div>
        <div class="sec-bot-tips">
        </div>
      </div>
      <div class="third_page">
        <div class="title"></div>
        <!-- 设置左右切换按钮 -->
        <div class="swiper-button-next3 ani-btn"></div>
        <div class="swiper-button-prev3 ani-btn"></div>
        <div class="swiper-container1 swiper-class" ref="mySwiper1">
          <div class="swiper-wrapper">
            <!-- 插入你的轮播内容 -->
            <div class="swiper-slide" v-for="(item, index) in mdv" :key="index">
              <img class="swiper-lazy" style="width: 100%;" :src="item.photo" alt="" />
            </div>
          </div>
        </div>
        <div class="arrow_down ani-01"></div>
      </div>

      <div class='content-page'>
        <div class="fourth_page ">
          <div class="title"></div>
          <div class="banner-box ani">
            <img class="video-img" v-if="!isVideo" src="https://download4.qcplay.com/h5-images/active/servitor/nySign/pv-img.png" />
            <div class="video-overlay">
              <div class="play-button" v-if="!isVideo" @click="playVideo">
              </div>
            </div>
          </div>

        </div>
        <div class="bot-title"></div>
      </div>
      <Footer :gameName="gameName" />
    </div>


    <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" />
    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :loginTypes="loginTypes"
      :downloadUrl="downloadUrl" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>

    <!-- 弹窗类 -->

    <!-- 视频详情 -->
    <div class="wx_wrap popup_wrap" v-show="isVideo">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">

        <video id="media-play" controls="controls" controlslist="nodownload" disablepictureinpicture="true"
          style="background-color: black;" ref="videoRef" v-show="isVideo" :src="videoSrc" autoplay
          @ended="isVideo = false"></video>
      </transition>
      <div v-show="isVideo" class="close-btn" @click="closeVideo">
        <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/servitor/assets/images/login/close_icon.png" alt="关闭按钮" />
      </div>
      <div class="close-bg" v-if="isVideo" @click="closePopup('isVideo')"></div>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>


    <!-- 分享弹窗 -->
    <div class="wx_wrap popup_wrap" v-show="sharePopup">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="share-img">
          <img class="price_img" src="https://download4.qcplay.com/h5-images/active/servitor/active/servitor/nySign/popup/join.png" />
          <div class="share-url">{{ copyUrl }}</div>
          <div class="copy-btn" @click="onCopy()" id="my-code" :data-clipboard-text="`《使魔计划》神龙庙会活动现已开启！游戏内红包雨限时启动！快来签到领取资源:${copyUrl}`"></div>
        </div>
      </transition>

      <div class="close-bg" v-if="sharePopup" @click="closePopup('sharePopup')"></div>
    </div>

    <!-- 签到失败弹窗 -->
    <div class="wx_wrap popup_wrap" v-show="signFail">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <img class="sign_fail_img" src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/popup/sign-fail.png"
        @click="closePopup('signFail')" />
      </transition>
      <div class="close-bg" v-if="signFail" @click="closePopup('signFail')"></div>
    </div>

    <!-- 签到成功1~6 -->
    <div class="wx_wrap popup_wrap" v-show="signSuceess">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="sign-fir" @click="closePopup('signSuceess')">
          <img src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/reward/1.png" alt="" v-if="signProgress == 1"
            class="img1" />
          <img src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/reward/2.png" alt="" v-if="signProgress == 2"
            class="img2" />
          <img src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/reward/3.png" alt="" v-if="signProgress == 3"
            class="img3" />
          <img src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/reward/4.png" alt="" v-if="signProgress == 4"
            class="img4" />
          <img src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/reward/5.png" alt="" v-if="signProgress == 5"
            class="img5" />
          <img src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/reward/6.png" alt="" v-if="signProgress == 6"
            class="img6" />
        </div>
      </transition>
      <div class="close-bg" v-if="signSuceess" @click="closePopup('signSuceess')"></div>
    </div>
    <!-- 签到成功第七天 -->
    <div class="wx_wrap popup_wrap" v-show="signSuceessSec">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="sign-sec" @click="goHere('https://l.taptap.cn/bpUf9bdY?channel=rep-rep_uf7pdrqihvf')">
        </div>
      </transition>
      <div class="close-bg" v-if="signSuceessSec" @click="closePopup('signSuceessSec')"></div>
    </div>

    <!-- 签到完毕后点击的弹窗 -->
    <div class="wx_wrap popup_wrap" v-show="signOver">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="sign-thr"  @click="goHere('https://l.taptap.cn/bpUf9bdY?channel=rep-rep_uf7pdrqihvf')">
        </div>
      </transition>
      <div class="close-bg" v-if="signOver" @click="closePopup('signOver')"></div>
    </div>
    <!-- 微信详情 -->
    <div class="wx_wrap popup_wrap" v-show="wxShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="wxShow">
          <div class="detail">
            <img src="https://download4.qcplay.com/h5-images/assets/images/active/servitor/anniversary/main/wechat_pop.png" alt="详情">
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="wxShow" @click="closePopup('wxShow')"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>

import Header from '@/components/Header/index';
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import MySwiper from '@/components/MySwiper';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard';
import { Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onGetInitDataAPI, onGetDayActiveAPI, onGetSignAPI, onDownloadApi, onGetShareRewardAPI } from '../api';
import {buriedLogger, wechatBrowser, getTimeStamp } from '@/utils/utils';
import Toast from '../components/toast/index.js';


export default {

  name: 'anniversary',
  components: {
    swiper,
    swiperSlide,
    MySwiper,
    Header,
    Footer,
    Login,
    Os
  },
  data () {
    return {
      mdv: [
        {
          photo: 'https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/show3.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/show2.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/assets/images/active/servitor/nySign/show1.png'
        },
      ],
      copyUrl: window.location.href,//分享链接
      videoSrc: '',
      headerConfig,
      noSwiperClass: '', // swiper-no-swiping
      gameName: "servitor",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: 'http://smjh.qingcigame.com/leading/',
      preloadingShow: true,
      titleShow: false,
      swiperA: null,
      GifImages: [],
      active_Info: {
        reward_list: [],
        times: 0
      }, // 活动信息
      user_info: {}, // 用户信息
      currentIndex: 1,
      gifInterval: null, // 定时器
      isUserInfo: false, // 是否获取用户信息
      shareLink: '',
      // 复制使用的文案
      clipInfo: '',
      shareShow: false,
      shareImg: null,
      sharePopup: false,// 分享弹窗
      isVideo: false, // 是否为视频
      wxShow: false,
      preventShow: false,
      paymentTipsShow: false,
      assistShow: false,
      isWechatBrowser: false, // 是否为微信浏览器
      wxLoadShow: false,
      swiper: null,
      signList: [],//签到记录
      signFail: false,//签到失败
      signProgress: 0,//签到进度
      signSuceess: false,//签到成功
      signSuceessSec: false,//第七天
      signOver: false
    };
  },
  created () {
    this.getUserInfo()
    this.setInitActiveInfo();
    this.setInitUserInfo();
    this.isWechatBrowser = wechatBrowser();
    // 埋点
    const bl = buriedLogger('servitor', '使魔计划新年签到活动');
    this.logger = bl;
  },
  mounted () {
    var swiper1 = new Swiper('.swiper-container1', {
      effect: 'coverflow',
      initialSlide: 1,
      slidesPerView: 3,
      centeredSlides: true,
      observer: true,
      observerParents: true,
      prevButton: '.swiper-button-prev3',
      nextButton: '.swiper-button-next3',
      speed: 500,
      coverflow: {
        rotate: 0,
        stretch: 10,
        depth: 12,
        modifier: 10,
        slideShadows: false,
      },
    });
    this.isSetShare()
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.clearActiveInfo();
        }
      }
    },
    activeInfo: {
      handler (newValue, oldValue) {
        if (Object.keys(newValue).length > 0) {
          const { countdown_time = '', is_echarge } = newValue;
          this.showPayBtn = is_echarge === false;
          if (countdown_time) {
            const date = new Date(countdown_time);
            const curDate = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            this.isExpired = curDate.getTime() > date.getTime();
            this.endDate = `${year}年${month}月${day > 9 ? day : ('0' + day)}日`
          } else {
            this.isExpired = true;
            this.endDate = '';
          }
        }
      }
    },
  },
  methods: {
    // 复制链接
    onCopy () {
      const clipboard = new Clipboard('#my-code');
      clipboard.on('success', (e) => {
        this.sharePopup = false
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        this.onToast('复制失败');
      });
      this.logger.sum('使魔计划新年签到活动5，复制成功');
    },
    closeVideo () {
      this.isVideo = false
      this.videoSrc = ''
      this.$refs.videoRef.pause();
    },
    playVideo () {
      this.videoSrc = 'https://download4.qcplay.com/tideng/rework-web/normal%20video.mp4'
      this.$refs.videoRef.play()
      this.isVideo = true
      this.logger.sum('使魔计划新年签到活动5，播放视频');
    },
    onDownloadApi () {
      onDownloadApi().then(res => {
        const userAgent = navigator.userAgent;
        if (/iPhone|iPod/i.test(userAgent)) {
          this.logger.sum('使魔计划新年签到活动5，ios下载');
          this.goHere(res.data["ios_down_url"]);
          if (this.isWechatBrowser) {
            // 微信浏览器
            this.wxLoadShow = true;
          }
        } else {
          this.logger.sum('使魔计划新年签到活动5，安卓下载');
          const url = 'https://download4.qcplay.com/apk-v2/qc-kol-1143856.apk'
          console.log(url, 'android')
          this.goHere(url);
          if (this.isWechatBrowser) {
            // 微信浏览器
            this.wxLoadShow = true;
          }
        }
      })
    },
    goHere (link) {
      if (link === 'https://www.taptap.cn/app/7091') {
        this.logger.sum('使魔计划新年签到活动5，taptap');
      }
      if (link === 'https://weibo.com/u/6573151992') {
        this.logger.sum('使魔计划新年签到活动5，weibo');
      }

      if (link === 'wx') {
        this.logger.sum('使魔计划新年签到活动5，微信');
        return this.wxShow = true
      }
      window.location.href = link
    },
    closeShare () {
      this.shareShow = false;
    },
    // 微信分享
    isSetShare () {
      let link = 'https://h5.qingcigame.com/servitor/nySign/enter'
      this.setShare({
        link: `${link}${getTimeStamp()}`,
        title: '《使魔计划》新年签到活动',
        imgUrl:
          'https://download4.qcplay.com/qcgame-api/hKig1khbVYM8bcoGeNbEAZKJPPavHnMj8Q0hzSMK.png',
        desc: '《使魔计划》神龙庙会活动现已开启~快来签到领取资源！游戏内还有红包雨限时掉落！',
      })
    },
    // 获取用户信息
    getUserInfo () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.signProgress = 0;
        this.preloadingShow = false;
        this.titleShow = true;
        if (response.code == 200) {
          this.active_Info = response.data.activity;
          this.user_info = response.data.user_info;
          this.signList = response.data.activity.sign_list;
          this.signList.forEach(item=>{
            if(item>0) {
              this.signProgress++
            }
          })
          this.isUserInfo = false;
          this.onGetDayActiveAPI()
        } else {
          this.isUserInfo = true
          this.onToast(response.message);
          this.setInitUserInfo();
          this.setInitActiveInfo();
        }
      }).catch(() => {
        this.preloadingShow = false;
        this.titleShow = true;
      });
    },
    // 签到
    signBtn () {
      this.logger.sum('使魔计划新年签到活动5，点击签到');
      if (this.isUserInfo) {
        return this.onToast('很抱歉，请先登录')
      }
      if (this.signProgress == 7) {
        return this.signOver = true;
      }
      if(this.active_Info.is_day_sign) {
        return this.onToast('今天已签到')
      }
      onGetSignAPI().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.onToast('签到成功!');
          this.signProgress++;
          if(this.signProgress <7){
            this.signSuceess = true;
            return
          }
          this.signSuceessSec = true
        }
        else if (res.code == 405) {
          this.signFail = true
        }
        else {
          this.onToast(res.message);
        }
      })
    },
    // 获取日活
    onGetDayActiveAPI () {
      onGetDayActiveAPI().then((res) => {
        this.active_Info.activation = res.data.activation;
      });
    },
    // 每日分享
    sharePopupBtn(){
      this.logger.sum('使魔计划新年签到活动5，点击分享');
      if (this.isUserInfo) {
        return this.onToast('很抱歉，请先登录')
      }
      this.sharePopup = true
      if(this.active_Info.share) return
      onGetShareRewardAPI().then(() => {
        this.getUserInfo()
      })
    },
    // 清除data里面相关数据
    clearActiveInfo () {
      this.signList =[];
      this.signProgress = 0;
      this.showPayBtn = true;
      this.endDate = '';
      this.isExpired = false;
    },
    // 选择角色后
    selectCallback () {
      this.shareImg = null
      this.getUserInfo();
    },
    osCancell () {
      this.active_Info = []
      this.user_info = []
      this.isUserInfo = true;
    },
    closePopup (name) {
      this[name] = false;
    },
    onToast (config) {
      const curConfig = {
        duration: 1300,
        className: "toasts",
        customStyle: { 'padding': '10px' }
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.msg = config;
      }
      // Toast(curConfig);
      Toast.install(curConfig);
    },
    // 前往游戏
    goGame(){
      // 判断是否为微信浏览器
      if (this.isWechatBrowser) {
        window.location.href = this.downloadUrl
        return
      }
      window.location.href = 'qcplaysmjh://'
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setActiveInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
 


// WEBPACK FOOTER //
// src/pages/servitor/nySign/index/index.vue